import { setTerm } from './helpers';

export const setPikPromo = setTerm('is_pik_promo');
